<div #preorderTableContainer>
  <div class="row table-container pt-4">
    <div class="col-6 col-md-4 col-lg-4 text-end px-0 position-relative" style="max-width: 180px">
      <i class="info info-1 position-absolute material-icons" style="right: 0px" *ngIf="showOrBeforeOption" [ngbTooltip]=" 'PREFERRED_WEEK_SELECT_PREORDER_EXPLANATION' | translate"
                [autoClose]="false">info</i>
      @if (article && !article.is_mandatory_item) {
        <table class="">
          <tr class="tableHeader d-block">
            <td class="text-end">&nbsp;</td>
          </tr>
          @if (article && article.matrix) {
            @for (option of matrixOptions; track option) {
              @for (optionArticle of option.value; track optionArticle) {
                <tr class="d-block" [ngClass]="'article-' + optionArticle.single_article_code">
                  <td class="text-end d-flex flex-nowrap">
                    <small class="me-2 d-inline-block" [ngClass]="[option.value.length > 1 ? 'multiple' : '']"
                      style="min-width: 65px; transform: translateY(4px)">{{optionArticle.single_article_code}}
                      @if (option.value.length > 1) {
                        <br />{{option.description}}
                      }
                    </small>
                    <button
                    [ngStyle]="{
                      'font-size': ((option.value.length > 1 ? optionArticle.value : option.description)?.length > 4) ? 'xx-small' : null
                    }"
                      class="btn btn-dark articleRowLabel"
                      [triggers]="touchscreen?'click':'hover'"
                      placement="top"
                      [ngbTooltip]="optionArticle | statusText:false:true"
                    [ngClass]="[
                      useTimeSlots ? 'timeSlot' : '',
                      optionArticle.single_article_code === article.single_article_code ? 'btn-primary selected' : 'btn-dark',
                      'company_' + optionArticle.company_id,
                      'status_' + (optionArticle.always_order && optionArticle.stock_week == 99 ? '3' : (optionArticle.stock_status >= 0 ? optionArticle.stock_status : 5))
                    ]"
                      >
                      {{option.value.length > 1 ? optionArticle.value : option.description}}
                      <i></i>
                    </button>
                  </td>
                </tr>
              }
            }
          }
        </table>
      }

    </div>
    @if (schedule && schedule.length) {
      <div class="col-6 col-md-8 col-lg-8 col-xl-9 ps-0 customScrollbar position-relative"
        [ngClass]="schedule && schedule.length > 8 ? 'overflow-auto' :''">
       
        <table #container class="float-left" [ngClass]="!article.single_article_code ? 'noSelection' : ''">
          @if (article && !article.is_mandatory_item) {
            <tr class="tableHeader d-block">
              <td class="p-0"></td>
              <td>
                <span class="d-inline-block text-center deliverNow" [ngClass]="{'timeSlot':useTimeSlots}" placement="right" triggers="click:blur"
                  ngbTooltip="{{'DELIVER_WHEN_POSSIBLE'|translate}}">
                  <img src="./assets/images/now.svg">
                </span>
              </td>
              @if (!onlyFlex) {
                @if (schedule.length && schedule[0].month > 1) {
                  <td class="yearDivider">
                    {{startYear}} &raquo;
                  </td>
                }
                <ng-container>
                  @for (month of schedule; track month; let monthIndex = $index) {
                    @if (month.month === 1) {
                      <td class="yearDivider">
                        {{startYear + (month.year - startYear)}} &raquo;
                      </td>
                    }
                    @if (!useTimeSlots || availableTimeSlots.indexOf(month.month) >= 0) {
                      <td>
                        <input type="text" readonly="true" [value]="monthDescriptions[month.month - 1]"
                          [ngClass]="{'timeSlot':useTimeSlots}" class="box border-0 text-center">
                      </td>
                    }
                  }
                </ng-container>
              }
              @if (showDemoRepair) {
                <td>
                  @if (article.retail_price && article.retail_price.value < demoMaxRetailPrice) {
                    <input type="text" readonly="true" [value]="'DEMO'|translate" [ngClass]="{'timeSlot':useTimeSlots}"
                      class="box border-0 text-center">
                  }
                </td>
                <td>
                  @if (article.retail_price && article.retail_price.value < repairMaxRetailPrice) {
                    <input type="text" readonly="true" [value]="'REPAIR'|translate" [ngClass]="{'timeSlot':useTimeSlots}"
                      class="box border-0 text-center">
                  }
                </td>
              }
            </tr>
          }
          @if (article && article.matrix && !article.is_mandatory_item) {
            @for (option of matrixOptions; track option) {
              @if (option.value.length === 1) {
                <tr class="d-block">
                  @for (optionArticle of option.value; track optionArticle) {
                    <td>
                      <app-preorder-month-input [inputIndex]="0" [monthSelectionOnly]="monthSelectionOnly" [type]="type" [month]="{}" [optionArticle]="optionArticle"
                        (checkQuantity)="checkQuantity()" [ngClass]="{'timeSlot':useTimeSlots}" [brand]='article.brand'
                        [value]="selectedArticles[optionArticle.single_article_code] ? selectedArticles[optionArticle.single_article_code]['amount'] : ''">
                      </app-preorder-month-input>
                    </td>
                    @if (schedule.length && schedule[0].month > 1 && !onlyFlex) {
                      <td class="yearDivider">
                        <span>{{startYear}} &raquo;</span>
                      </td>
                    }
                    @for (month of schedule; track month; let monthIndex = $index) {
                      @if (month.month === 1) {
                        <td class="yearDivider">
                          <span>{{startYear + (month.year - startYear)}} &raquo;</span>
                        </td>
                      }
                      @if ((!useTimeSlots || availableTimeSlots.indexOf(month.month) >= 0) && !onlyFlex) {
                        <td>
                          <app-preorder-month-input [monthSelectionOnly]="monthSelectionOnly" [type]="type" [month]="month" [optionArticle]="optionArticle"
                            [ngClass]="{'timeSlot':useTimeSlots}" [brand]='article.brand' (checkQuantity)="checkQuantity()"
                            [value]="selectedArticles[optionArticle.single_article_code+month.month.toString()+month.deliveryYear.toString()] ? selectedArticles[optionArticle.single_article_code+month.month.toString()+month.deliveryYear.toString()]['amount'] : ''">
                          </app-preorder-month-input>
                        </td>
                      }
                    }
                    @if (showDemoRepair) {
                      <td>
                        @if (optionArticle.retail_price && optionArticle.retail_price.value < demoMaxRetailPrice) {
                          <app-preorder-month-input [monthSelectionOnly]="monthSelectionOnly" [type]="type" [month]="demo" [max]="'5'" [optionArticle]="optionArticle"
                            [ngClass]="{'timeSlot':useTimeSlots}" [brand]='article.brand' (checkQuantity)="checkQuantity()"
                            [attr.data-test]="optionArticle.single_article_code+'month'"
                            [value]="selectedArticles[optionArticle.single_article_code+'demo'] ? selectedArticles[optionArticle.single_article_code+'demo']['amount'] : ''">
                          </app-preorder-month-input>
                        }
                      </td>
                      <td>
                        @if (optionArticle.retail_price && optionArticle.retail_price.value < repairMaxRetailPrice) {
                          <app-preorder-month-input [monthSelectionOnly]="monthSelectionOnly" [type]="type" [month]="repair" [max]="'5'" [optionArticle]="optionArticle"
                            [ngClass]="{'timeSlot':useTimeSlots}" [brand]='article.brand' (checkQuantity)="checkQuantity()"
                            [attr.data-test]="optionArticle.single_article_code+'repair'"
                            [value]="selectedArticles[optionArticle.single_article_code+'repair'] ? selectedArticles[optionArticle.single_article_code+'repair']['amount'] : ''">
                          </app-preorder-month-input>
                        }
                      </td>
                    }
                  }
                </tr>
              }
              @if (option.value.length > 1) {
                @for (optionArticle of option.value; track optionArticle) {
                  <tr class="d-block">
                    <td>
                      <app-preorder-month-input [monthSelectionOnly]="monthSelectionOnly" [type]="type" [month]="{}"  [optionArticle]="optionArticle"
                        (checkQuantity)="checkQuantity()" [ngClass]="{'timeSlot':useTimeSlots}" [brand]='article.brand'
                        [value]="selectedArticles[optionArticle.single_article_code] ? selectedArticles[optionArticle.single_article_code]['amount'] : ''">
                      </app-preorder-month-input>
                    </td>
                    @if (!onlyFlex) {
                      @if (schedule.length && schedule[0].month > 1) {
                        <td class="yearDivider inRow">
                          <span>{{startYear}} &raquo;</span>
                        </td>
                      }
                      @for (month of schedule; track month; let monthIndex = $index) {
                        @if (month.month === 1) {
                          <td class="yearDivider">
                            <span>{{startYear + 1}} &raquo;</span>
                          </td>
                        }
                        @if ((!useTimeSlots || availableTimeSlots.indexOf(month.month) >= 0)) {
                          <td>
                            <app-preorder-month-input [monthSelectionOnly]="monthSelectionOnly" [type]="type" [month]="month" [optionArticle]="optionArticle"
                              [ngClass]="{'timeSlot':useTimeSlots}" [brand]='article.brand' (checkQuantity)="checkQuantity()"
                              [attr.data-test]="optionArticle.single_article_code+month.month.toString()+month.deliveryYear.toString()"
                              [value]="selectedArticles[optionArticle.single_article_code+month.month.toString()+month.deliveryYear.toString()] ? selectedArticles[optionArticle.single_article_code+month.month.toString()+month.deliveryYear.toString()]['amount'] : ''">
                            </app-preorder-month-input>
                          </td>
                        }
                      }
                    }
                    @if (showDemoRepair) {
                      <td>
                        @if (optionArticle.retail_price && optionArticle.retail_price.value < demoMaxRetailPrice) {
                          <app-preorder-month-input [monthSelectionOnly]="monthSelectionOnly" [type]="type" [month]="demo" [max]="'5'" [optionArticle]="optionArticle"
                            [ngClass]="{'timeSlot':useTimeSlots}" [brand]='article.brand' (checkQuantity)="checkQuantity()"
                            [attr.data-test]="optionArticle.single_article_code+'month'"
                            [value]="selectedArticles[optionArticle.single_article_code+'demo'] ? selectedArticles[optionArticle.single_article_code+'demo']['amount'] : ''">
                          </app-preorder-month-input>
                        }
                      </td>
                      <td>
                        @if (optionArticle.retail_price && optionArticle.retail_price.value < repairMaxRetailPrice) {
                          <app-preorder-month-input [monthSelectionOnly]="monthSelectionOnly" [type]="type" [month]="repair" [max]="'5'" [optionArticle]="optionArticle"
                            [ngClass]="{'timeSlot':useTimeSlots}" [brand]='article.brand' (checkQuantity)="checkQuantity()"
                            [attr.data-test]="optionArticle.single_article_code+'repair'"
                            [value]="selectedArticles[optionArticle.single_article_code+'repair'] ? selectedArticles[optionArticle.single_article_code+'repair']['amount'] : ''">
                          </app-preorder-month-input>
                        }
                      </td>
                    }
                  </tr>
                }
              }
            }
          }
          @if (article && article.is_mandatory_item) {
            <tr>
              <td class="p-2">
                @if (article && article.is_mandatory_item) {
                  <label class="pt-2 pe-2">
                    {{"QUANTITY"|translate}}:
                  </label>
                }
                <app-preorder-month-input [monthSelectionOnly]="monthSelectionOnly" [type]="type" [month]="{}" [optionArticle]="article"
                  (checkQuantity)="checkQuantity()" [ngClass]="{'timeSlot':useTimeSlots}" [brand]='article.brand'
                  [value]="selectedArticles[article.single_article_code] ? selectedArticles[article.single_article_code]['amount'] : ''">
                </app-preorder-month-input>
              </td>
            </tr>
          }
        </table>
      </div>
    }
  </div>
  <div class="">
    @if ((type === 'wishlist' || article.is_favorite) && !article.is_mandatory_item) {
      <button class="btn mt-2 btn-outline-danger me-2"
      (click)="removeFromWishList()">{{'REMOVE_FROM_WISHLIST'|translate}}</button>
    }

    @if (type !== 'wishlist' && !article.is_favorite && !article.is_mandatory_item) {
      <button class="btn mt-2 btn-dark me-2"
        [disabled]="loading_wishlist" style="min-width: 150px;" (click)="addToWishList()">
        @if (!loading_wishlist) {
          {{'ADD_TO_WISHLIST'|translate}}
        }
        @if (loading_wishlist) {
          <div class="spinner spinner-border spinner-border-sm text-white " role="status">
            <span class="visually-hidden">{{'LOADING'|translate}}</span>
          </div>
        }
      </button>
    }
    @if ((!addedToBasket || selectedArticles) && !hideSaveButton) {
      <button class="btn mt-2" style="min-width: 100px;"
        [disabled]="(!addEnabled && !selectedArticles) || loading"
        [ngClass]="addEnabled || selectedArticles ? 'btn-success' : 'disabled btn-default'" (click)="addToBasket()">
        @if (!loading) {
          {{(type === 'wishlist'?'ADD_TO_BASKET':'SAVE_PREORDER')|translate}}
        }
        @if (loading) {
          <div class="spinner spinner-border spinner-border-sm text-white " role="status">
            <span class="visually-hidden">{{'LOADING'|translate}}</span>
          </div>
        }
      </button>
    }
    <ng-content></ng-content>

  </div>
  @if (addedToBasket && !selectedArticles && type !== 'wishlist') {
    <div class="">
      <button class="btn btn-outline-success d-block mb-1">{{'ADDED'|translate}}</button>
      <span class="text-primary d-block clickable withOpacity"
      (click)="resetForm(); addEnabled = false; addedToBasket = false">{{'RESET'|translate}}</span>
    </div>
  }
</div>
